import { useContext } from 'react'
import { GoogleReCaptchaContext } from './RecaptchaProvider'

export const useGoogleReCaptcha = () => useContext(GoogleReCaptchaContext)
